import React from "react";
import Jumbotron from "../components/Jumbotron";
import CallToAction from "../components/CallToAction";
import FeaturedStory from "../components/FeaturedStory";
import FeaturedQuarters from "../components/FeaturedQuarters";
import CollaboratorsGrid from "../components/CollaboratorsGrid";
import PageWrapper from "../components/PageWrapper";
import Helmet from "react-helmet";

import "../styles/Homepage.scss";

function createMarkup(value) {
	return {
		__html: value
	};
}

const Homepage = ({ transition, data, location }) => {
	const topBanner = data.topBanner.edges[0].node;
	const cta = data.cta.edges[0].node;
	const funders = data.funders.edges[0].node.fundersCollaborators;
	const news = data.news.edges;
	const researchSpotlight = data.researchSpotlight.edges;
	const { pageSettings } = data;

	return (
		<PageWrapper
			locale={pageSettings.node_locale}
			location={location}
			data={data.layout.edges[0].node}
		>
			<main role="main" style={transition && transition.style}>
				<Helmet
					title={
						"Mahidol Vivax Research Unit | " +
						topBanner.topBannerText.content.excerpt
					}
				/>
				<Jumbotron
					className="mb-0"
					textAlign="text-center"
					contentAlign="justify-content-md-center"
					backgroundImage={topBanner.topBannerImage.sizes.src}
				>
					<span
						dangerouslySetInnerHTML={createMarkup(
							topBanner.topBannerText.content.html
						)}
					/>
				</Jumbotron>

				<CallToAction
					leadText=""
					text={cta.content.childMarkdownRemark.html}
					buttonLabel={cta.buttonLabel}
					destination={`/${pageSettings.node_locale}${cta.linkTo}`}
					arrow={true}
					className="landing_message"
				/>

				<FeaturedStory story={researchSpotlight[0].node} />
				<div className="grey_bg" style={{ paddingBottom: "1rem" }}>
					<FeaturedQuarters
						relatedPosts={false}
						locale={pageSettings.node_locale}
						className="container py-3"
						articles={[
							{
								title: news[0].node.title,
								category: news[0].node.cat,
								category_url:
									"/" +
									news[0].node.node_locale +
									"/news/cat/" +
									news[0].node.cat,
								published_date: news[0].node.datePublished,
								url:
									"/" +
									news[0].node.node_locale +
									"/news/" +
									news[0].node.slug
							},
							{
								title: researchSpotlight[1].node.title,
								category: "Research Spotlight",
								category_url:
									"/" +
									researchSpotlight[1].node.node_locale +
									"/research",
								published_date:
									researchSpotlight[1].node.datePublished,
								url:
									"/" +
									researchSpotlight[1].node.node_locale +
									"/research/story/" +
									researchSpotlight[1].node.slug
							},
							{
								title: news[1].node.title,
								category: news[1].node.cat,
								category_url:
									"/" +
									news[1].node.node_locale +
									"/news#" +
									news[1].node.cat,
								published_date: news[1].node.datePublished,
								url:
									"/" +
									news[1].node.node_locale +
									"/news/" +
									news[1].node.slug
							},
							{
								title: news[2].node.title,
								category: news[2].node.cat,
								category_url:
									"/" +
									news[2].node.node_locale +
									"/news#" +
									news[2].node.cat,
								published_date: news[2].node.datePublished,
								url:
									"/" +
									news[2].node.node_locale +
									"/news/" +
									news[2].node.slug
							}
							// {
							// 	title:
							// 		"Imported Plasmodium falciparum and locally transmitted Plasmodium vivax: cross-border malaria transmission scenario in northwestern Thailand.",
							// 	category: "Publications",
							// 	category_url: "/publications",
							// 	author: "",
							// 	published_date: "22 Jan 2561",
							// 	url: "/publications"
							// }
						]}
					/>
				</div>

				{/*<div className="grey_bg">
					<div
						className="container "
						style={{
							paddingBottom: "2rem",
							position: "relative"
						}}
					>
						<div className="row bg-white justify-content-around triple_link_wrapper">
						
	
							<Link to="/research#areas" className={"triple_link"}>
								Discover our research areas &raquo;
							</Link>
	
							<Link to="/careers" className={"triple_link"}>
								Explore career opportunities &raquo;
							</Link>
						</div>
					</div>
				</div>
				 <div className="grey_bg" style={{ paddingTop: "3rem" }}>
				<CallToAction
					className="py-5"
					leadText="Let’s have a chat"
					text="Speak to one of our researchers to learn more about us. We’re always interested to chat!"
					buttonLabel="Contact us"
					destination="/contact"
					arrow={true}
				/>
			</div> */}

				<CollaboratorsGrid
					title={
						pageSettings.node_locale === "th"
							? "MVRU ร่วมงานกับ"
							: "MVRU works with"
					}
					list={funders}
					count={9}
				/>
			</main>
		</PageWrapper>
	);
};

export default Homepage;

export const pageQuery = graphql`
	query homepageQuery($id: String!, $locale: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		pageSettings: contentfulHomepage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		topBanner: allContentfulTopBanner(
			limit: 1
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					topBannerImage {
						title
						sizes(maxWidth: 1400, quality: 90) {
							src
						}
					}
					topBannerText {
						content: childMarkdownRemark {
							html
							excerpt
						}
					}
				}
			}
		}

		cta: allContentfulCallToAction(
			limit: 1
			filter: {
				pageLocation: { eq: "homepage" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}

		news: allContentfulNews(
			filter: { node_locale: { eq: $locale } }
			limit: 3
			sort: { order: DESC, fields: [datePublished] }
		) {
			edges {
				node {
					title
					slug
					datePublished(formatString: "Do MMMM, YYYY")
					cat
					node_locale
				}
			}
		}

		researchSpotlight: allContentfulResearchSpotlightStory(
			filter: { node_locale: { eq: $locale } }
			limit: 2
			sort: { order: DESC, fields: [datePublished] }
		) {
			edges {
				node {
					node_locale
					title
					slug
					datePublished(formatString: "Do MMMM, YYYY")
					featuredImage {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							srcWebp
							srcSetWebp
							sizes
						}
					}
					content {
						childMarkdownRemark {
							excerpt(pruneLength: 160)
						}
					}
				}
			}
		}

		funders: allContentfulMvruWorksWith(
			limit: 1
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					fundersCollaborators {
						name
						logo {
							sizes(
								maxHeight: 250
								quality: 85
								resizingBehavior: PAD
							) {
								base64
								aspectRatio
								src
								srcSet
								srcWebp
								srcSetWebp
								sizes
							}
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/homepage-template.js